const commaSeparatedArray = (params) => {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      searchParams.set(key, value.join(","));
      return;
    }

    searchParams.set(key, value);
  });

  return searchParams.toString();
};

export default commaSeparatedArray;
